var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sortWrapper"},[_c('NakedDropdown',{attrs:{"label":_vm.$t('GENERAL.SORT_BY'),"items":_vm.options,"default-value":_vm.value,"right-aligned":""},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }